import { axiosInstance } from "./axiosInstance";
import { message } from "antd";

export const techCardsAPI = {
  create: (token) => async (data) => {
    console.log("📤 Creating tech card with token:", token, "data:", JSON.stringify(data, null, 2));
    try {
      const response = await axiosInstance.post(`/tech_cards/?token=${token}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("📥 Create response:", JSON.stringify(response.data, null, 2));
      message.success("✅ Тех. карта успешно создана");
      return response;
    } catch (error) {
      console.group('❌ API Error Details (Create)');
      console.log('Status:', error.response?.status);
      console.log('Status Text:', error.response?.statusText);
      console.log('Full Response Data:', JSON.stringify(error.response?.data, null, 2));
      console.log('Request Config:', error.config);
      console.log('Redirect URL:', error.response?.headers?.location);
      console.groupEnd();
      if (error.response?.status === 422) {
        const errorData = error.response.data;
        if (errorData.detail) {
          errorData.detail.forEach((err, index) => {
            console.error(`Error ${index + 1}:`, err);
            if (err.loc && err.msg) {
              const fieldName = err.loc[err.loc.length - 1];
              message.error(`Ошибка в поле "${fieldName}": ${err.msg}`);
            }
          });
        } else {
          message.error(`Ошибка валидации: ${JSON.stringify(errorData.detail)}`);
        }
      } else {
        message.error("❌ Ошибка при создании тех. карты");
      }
      throw error;
    }
  },
  getItemsWithDetails: (params = {}) => {
    console.log("📤 Getting items with details, params:", params);
    return axiosInstance.get(`/tech_cards/`, {
      params: { ...params, include_items: true, limit: 500 },
    }).then(response => {
      console.log("📥 Get items with details response:", JSON.stringify(response.data, null, 2));
      return response;
    }).catch(error => {
      console.error("❌ Error getting items with details:", error);
      throw error;
    });
  },
  getItems: (params = {}) => {
    console.log("📤 Getting items, params:", params);
    return axiosInstance.get(`/tech_cards/`, {
      params: { ...params, limit: 500 },
    }).then(response => {
      console.log("📥 Get items response:", JSON.stringify(response.data, null, 2));
      return response;
    }).catch(error => {
      console.error("❌ Error getting items:", error);
      throw error;
    });
  },
  getTechCardItems: (token, id) => {
    console.log("📤 Getting tech card items for id:", id, "with token:", token);
    return axiosInstance.get(`/tech_cards/${id}/items?token=${token}`).then(response => {
      console.log("📥 Get tech card items response:", JSON.stringify(response.data, null, 2));
      return response;
    }).catch(error => {
      console.error("❌ Error getting tech card items:", error);
      throw error;
    });
  },
  addTechCardItem: (token) => async (id, itemData) => {
    console.log("📤 Adding item to tech card with id:", id, "data:", JSON.stringify(itemData, null, 2), "token:", token);
    try {
      const response = await axiosInstance.post(`/tech_cards/${id}/items?token=${token}`, itemData, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("📥 Add item response:", JSON.stringify(response.data, null, 2));
      message.success("✅ Позиция успешно добавлена");
      return response;
    } catch (error) {
      console.group('❌ API Error Details (Add Item)');
      console.log('Status:', error.response?.status);
      console.log('Status Text:', error.response?.statusText);
      console.log('Full Response Data:', JSON.stringify(error.response?.data, null, 2));
      console.log('Request Config:', error.config);
      console.log('Redirect URL:', error.response?.headers?.location);
      console.groupEnd();
      message.error("❌ Ошибка при добавлении позиции");
      throw error;
    }
  },
  update: (token) => async (data, id) => {
    console.log("📤 Updating tech card with id:", id, "data:", JSON.stringify(data, null, 2), "token:", token);
    try {
      const response = await axiosInstance.put(`/tech_cards/${id}?token=${token}`, data, {
        headers: { "Content-Type": "application/json" },
        maxRedirects: 0, 
      });
      console.log("📥 Update response:", JSON.stringify(response.data, null, 2));
      message.success("✅ Тех. карта успешно обновлена");
      return response;
    } catch (error) {
      console.group("❌ API Error Details (Update)");
      console.log('Status:', error.response?.status);
      console.log('Status Text:', error.response?.statusText);
      console.log('Full Response Data:', JSON.stringify(error.response?.data, null, 2));
      console.log('Request Config:', error.config);
      console.log('URL:', error.config.url);
      console.log('Method:', error.config.method);
      console.log('Headers:', error.config.headers);
      console.log('Redirect URL:', error.response?.headers?.location);
      console.groupEnd();
      if (error.response?.status === 422) {
        const errorData = error.response.data;
        if (errorData.detail) {
          errorData.detail.forEach((err, index) => {
            console.error(`Error ${index + 1}:`, err);
            if (err.loc && err.msg) {
              const fieldName = err.loc[err.loc.length - 1];
              message.error(`Ошибка в поле "${fieldName}": ${err.msg}`);
            }
          });
        } else {
          message.error(`Ошибка валидации: ${JSON.stringify(errorData.detail)}`);
        }
      } else {
        message.error("❌ Ошибка при обновлении тех. карты");
      }
      throw error;
    }
  },
  remove: (token) => async (id) => {
    console.log("📤 Removing tech card with id:", id, "token:", token);
    try {
      const response = await axiosInstance.delete(`/tech_cards/${id}?token=${token}`, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("📥 Remove response:", JSON.stringify(response.data, null, 2));
      message.success("✅ Тех. карта удалена");
      return response;
    } catch (error) {
      console.error('Error removing tech card:', error);
      message.error("❌ Ошибка при удалении тех. карты");
      throw error;
    }
  }
};